import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintManager_ds_support_tests_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { test_ids?: number[], test_runs?: number, rows_override?: number, $top?: number, $skip?: number }): Promise<{ result?: { id?: number, test_name?: string, records_available?: number, records_returned?: number, elapsed_seconds?: number, seconds_per_record?: number, notes?: string }[], totalCount?: number }> {
    let url = `${environment.backendUrl}api/FootprintManager/datasources/ds_support_tests_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { test_ids?: number[], test_runs?: number, rows_override?: number, $keys: number[] }): Promise<{ result?: { id?: number, test_name?: string, records_available?: number, records_returned?: number, elapsed_seconds?: number, seconds_per_record?: number, notes?: string }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/FootprintManager/datasources/ds_support_tests_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      test_ids?: number[], test_runs?: number, rows_override?: number    }) {
      return false;
    }
}
